import { AnyAction } from 'redux';
import { sortByProperty } from '@synergy/utils';

import { CONTACT_DETAILS_NOT_FOUND, RECEIVE_CONTACTS, RECEIVE_CONTACTS_SEARCH } from '../actions/contact-actions';
import { Contact } from '../models/contact';
import { RECEIVE_CONTACT_DETAILS, REQUEST_CONTACT_DETAILS } from './../actions/contact-actions';

export interface ContactReducerState {
    flat: Contact[];
    sortedByName: Contact[];
    searchResult: Contact[];
    contactDetailsLoading: boolean;
    contactDetails: { [key: number]: Contact | null };
}

const initialContactsReducerState: ContactReducerState = {
    flat: [],
    sortedByName: [],
    searchResult: [],
    contactDetailsLoading: false,
    contactDetails: {},
};

export const contactReducer = (
    state: ContactReducerState = initialContactsReducerState,
    action: AnyAction
): ContactReducerState => {
    switch (action.type) {
        case REQUEST_CONTACT_DETAILS: {
            return {
                ...state,
                contactDetailsLoading: true,
            };
        }

        case RECEIVE_CONTACTS: {
            return {
                ...state,
                flat: action['contacts'],
                sortedByName: sortByProperty<Contact>({ data: action['contacts'], key: 'fullName' }),
            };
        }

        case RECEIVE_CONTACT_DETAILS: {
            const newContactDetails = { ...state.contactDetails };
            newContactDetails[action['contact'].id] = action['contact'];

            return {
                ...state,
                contactDetails: newContactDetails,
                contactDetailsLoading: false,
            };
        }

        case CONTACT_DETAILS_NOT_FOUND: {
            const newContactDetails = { ...state.contactDetails };
            newContactDetails[action['contactId']] = null;

            return {
                ...state,
                contactDetails: newContactDetails,
                contactDetailsLoading: false,
            };
        }

        case RECEIVE_CONTACTS_SEARCH: {
            return {
                ...state,
                searchResult: action['contacts'],
            };
        }

        default: {
            return state;
        }
    }
};
